import i18next from 'i18next'

i18next.addResourceBundle('en', 'repository', {
    common: 'Common',
    name: 'Name',
    type: 'Type',
    url: 'URL',
    login: 'Login',
    password: 'Password',
    branch: 'Branch',
    protected_branches: 'Protected branches',
    user_message_templates: 'User message templates',
    changes_check_interval: 'Changes check interval (sec)',
    connection_timeout: 'Connection timeout (sec)',
    new_branch: 'New branch',
    default_branch_name: 'Default branch name',
    branch_name_pattern: 'Branch name pattern',
    invalid_branch_name_message_hint: 'Invalid branch name message hint',
    path: 'Path',
    comments: 'Comments',
    customize_comments: 'Customize comments',
    user_message_pattern: 'User message pattern',
    invalid_user_message_hint: 'Invalid user message hint',
    save_project: 'Save project',
    create_project: 'Create project',
    copy_project: 'Copy project',
    restore_from_old_version: 'Restore from old version',
    secure_connection: 'Secure connection',
    deployment_branch: 'Deployment branch',
    any_branch: 'Any branch',
    main_branch_only: 'Main branch only',
    service_endpoint: 'Service endpoint',
    bucket_name: 'Bucket name',
    region_name: 'Region name',
    access_key: 'Access key',
    secret_key: 'Secret key',
    listener_timer_period_sec: 'Listener timer period (sec)',
    sse_algorithm: 'SSE algorithm',
    add_repository: 'Add repository',
    none: 'None',
    home: {
        tree: {
            title: 'Projects',
            mode_filters: 'Filters',
            mode_tree: 'Tree',
            group: 'Group projects',
            group_title: 'Group Projects',
            level: 'Level {{level}}',
            level_none: '[None]',
            level_repository: '[Repository]',
            level_branch: '[Branch]',
            apply: 'Apply',
            refresh: 'Reload the tree',
            resize: 'Drag to resize',
            show_panel: 'Show the panel',
            hide_panel: 'Hide the panel',
            empty: 'No projects to show',
            search_placeholder: 'Search the tree',
            no_match: 'Nothing matches the search',
        },
        title: 'Projects',
        search_placeholder: 'Search by name, author, branch or tag',
        local: 'Local',
        summary: '{{workspace}} in your workspace · {{total}} total',
        summary_total: '{{total}} projects',
        live_synced: 'Projects list synced',
        indexing: 'Discovering projects across repository branches…',
        indexing_repositories_one: 'Indexing {{count}} repository',
        indexing_repositories_other: 'Indexing {{count}} repositories',
        indexing_banner: 'Still indexing branches for {{repos}} — projects there may not yet appear in every branch.',
        empty: 'No projects yet. Create one or import an archive to get started.',
        no_match: 'No projects match your filters',
        clear_filters: 'Clear all filters',
        retry: 'Retry',
        not_found: 'This project does not exist or is not visible to you.',
        back_to_projects: 'Back to projects',
        filters: 'Filters',
        reset: 'Reset',
        facet_status: 'Status',
        facet_repository: 'Repository',
        facet_branch: 'Branch',
        filter_group: {
            customize: 'Arrange the filters',
            done: 'Done',
            hide: 'Hide this filter',
            show: 'Show this filter',
            move: 'Drag to reorder',
            hidden_one: '{{count}} hidden filter',
            hidden_other: '{{count}} hidden filters',
        },
        view_list: 'List',
        view_grid: 'Grid',
        col_project: 'Project',
        col_branch: 'Branch',
        col_modified: 'Modified',
        row_actions: 'Actions',
    },
    deployments: {
        title: 'Deployments',
        repositories: 'Repositories',
        no_repositories: 'No deployment repositories',
        summary_one: '{{count}} deployment',
        summary_other: '{{count}} deployments',
        search_placeholder: 'Search deployments',
        retry: 'Retry',
        clear_search: 'Clear search',
        empty: 'No deployments in this repository',
        no_match: 'No deployments match your search',
        no_projects: 'No deployed projects',
        load_failed: 'Failed to load deployments',
        repositories_load_failed: 'Failed to load deployment repositories',
        back: 'Back to deployments',
        not_found: 'This deployment no longer exists',
        tab_projects: 'Projects',
        col_deployment: 'Deployment',
        col_project: 'Project',
        col_revision: 'Revision in Design Repository',
        revision_unknown: 'No design revision matches the deployed content. It is still being looked up if '
            + 'the project was just deployed, and stays unknown for a project deployed from another '
            + 'OpenL Studio.',
        col_modified_by: 'Modified By',
        col_modified_at: 'Modified At',
    },
    browser: {
        refresh: 'Refresh',
        load_error: 'Failed to load repositories',
        no_repositories: 'No repositories available',
        no_projects: 'No projects in this repository',
        local_projects: 'Local projects',
        new_project: 'New Project',
        open: 'Open',
        close: 'Close',
        live_project_synced: 'Project synced',
        live_file_synced: 'File "{{name}}" synced',
        open_project: {
            title: 'Open project "{{name}}"',
            confirm_button: 'Open',
            open_dependencies: 'Open Dependencies',
            other_branch_warning: 'The project is compiled against these dependencies as they are, which can '
                + 'fail. Switch the ones this repository keeps on another branch over to "{{branch}}" first. '
                + 'A dependency marked as not found stays unavailable until "{{branch}}" contains it.',
        },
        close_discard_title: 'Discard unsaved changes?',
        close_discard_warning: 'The project is modified. If you close the project, all changes will be lost.',
        close_discard_confirm_unsafe: 'I understand the consequences, close this project',
        open_revision_discard_warning: 'The project is modified. If you open the revision, all changes will be lost.',
        open_revision_discard_confirm_unsafe: 'I understand the consequences, open this revision',
        switch_branch_discard_warning: 'The project is modified. If you switch the branch, all changes will be lost.',
        switch_branch_discard_confirm_unsafe: 'I understand the consequences, switch branch',
        save: 'Save',
        deploy: 'Deploy',
        compare: 'Compare',
        delete: 'Delete',
        delete_confirm: 'Delete this project? This cannot be undone.',
        delete_failed: 'Failed to delete project',
        unlock: 'Unlock',
        unlock_confirm: 'Force-release this lock?',
        unlock_failed: 'Failed to unlock project',
        copy: 'Copy',
        copy_failed: 'Failed to copy project',
        export_dialog: {
            title: 'Export "{{name}}"',
            revision: 'Project Revision',
            file_revision: 'File Revision',
            viewing: 'Viewing',
            in_editing: 'In Editing',
            submit: 'Export',
            load_more: 'Load older revisions',
            file_missing: '"{{name}}" does not exist in the selected revision.',
            load_failed: 'Failed to load the project to export',
        },
        open_revision_dialog: {
            title: 'Open a revision of "{{name}}"',
            revision: 'Project Revision',
            revision_required: 'Choose the revision to open',
            note: 'NOTE: Project data in the workspace will be replaced by the data of the revision opened from the repository.',
            modified_warning: 'The project is modified. Opening a revision discards all unsaved changes.',
            submit: 'Open',
            success: 'The project was opened on the chosen revision',
        },
        copy_dialog: {
            title: 'Copy project',
            load_failed: 'Failed to load the project to copy',
            repositories_failed: 'Failed to load the repositories to copy into. Only a new branch can be created.',
            project_name: 'Project Name',
            as_new_project: 'Create a New Project',
            current_branch: 'Current Branch',
            new_branch: 'New Branch Name',
            target_repository: 'Repository',
            new_name: 'New Project Name',
            path: 'Path',
            path_placeholder: 'folder or path/to/folder',
            old_revision: 'Copy an Old Revision',
            revision: 'Revision',
            submit: 'Copy',
            name_required: 'Project name is required',
            branch_required: 'Branch name is required',
            branch_invalid: 'Enter a valid Git branch name that matches the pattern the repository requires',
            success: 'Project copied to "{{name}}"',
            branch_success: 'The project moved to branch "{{name}}"',
            branch_created_not_switched: 'Branch "{{name}}" was created, but the project has unsaved changes and stays on its current branch. Save or discard the changes, then switch to the new branch.',
            modified_warning: 'The project has unsaved changes. The new branch starts from the last commit, and moving the project onto it discards them.',
            branch_discard_confirm_unsafe: 'I understand the consequences, move to the new branch',
        },
        folder_picker: {
            open: 'Browse folders',
            select: 'Select',
            empty: 'No sub-folders',
        },
        comment: {
            label: 'Comment',
            invalid: 'The comment does not match the pattern the repository requires',
            too_long: 'The comment is longer than 255 characters',
        },
        export: 'Export',
        save_dialog: {
            load_failed: 'Failed to load the project to save',
        },
        save_title: 'Save project',
        save_desc: 'Changes are committed as a new revision in {{repository}}.',
        saved: 'Project saved',
        save_conflict: 'Your changes conflict with the latest version. Resolve the conflicts to continue.',
        save_failed: 'Failed to save project',
        status_change_failed: 'Failed to change project status',
        no_files: 'No files',
        files_error: 'Failed to load files',
        files: {
            upload: 'Upload',
            upload_failed: 'Failed to upload files',
            add: 'Add',
            new_folder: 'New folder',
            new_text_file: 'New text file',
            text_file_failed: 'Failed to create text file',
            name: 'Name',
            path: 'Path',
            new_file_name: 'New File Name',
            new_folder_name: 'New Folder Name',
            upload_hint: 'Click or drag a file here to upload it',
            search: 'Search files',
            no_match: 'No files match',
            download: 'Export',
            more_actions: 'More actions',
            update: 'Update',
            update_title: 'Update file "{{name}}"',
            update_succeeded: 'File "{{name}}" was updated',
            update_failed: 'Failed to update the file',
            download_archive: 'Export',
            copy: 'Copy',
            copy_title: 'Copy file',
            copy_folder_title: 'Copy folder',
            copy_failed: 'Failed to copy',
            move: 'Move',
            move_title: 'Move file',
            move_failed: 'Failed to move',
            rename: 'Rename',
            rename_title: 'Rename file',
            rename_failed: 'Failed to rename',
            discard_changes: 'Discard changes',
            discard_changes_desc: 'The current file has unsaved changes. Discard them and continue?',
            discard_changes_title: 'Unsaved changes',
            delete: 'Delete',
            delete_failed: 'Failed to delete',
            local_changes: 'Local changes ({{count}})',
            change: {
                added: 'Added',
                modified: 'Modified',
                deleted: 'Deleted',
            },
            select_hint: 'Select a file to view or edit',
            folder_hint: 'Select an action for this folder.',
            empty_folder_hint: 'This folder is empty. Add a file to save it.',
            remove_empty_folder: 'Remove empty folder',
            text_editor: 'Text editor',
            binary: 'Binary',
            binary_hint: 'This file type cannot be previewed here. Download it to view.',
        },
        more: 'More',
        search_placeholder: 'Search projects',
        select_project_hint: 'Select a project to see its details',
        no_match: 'No projects match your search',
        locked_by: 'Locked by {{by}} · {{at}}',
        tab_overview: 'Overview',
        tab_files: 'Files',
        tab_history: 'Revisions',
        sync: 'Sync',
        open_revision: 'Open Revision',
        delete_branch_action: 'Delete Branch',
        tab_publish: 'Deploy Configuration',
        tab_management: 'Management',
        deploy_config: {
            title: 'Deploy configuration',
            service_name: 'Service Name',
            url: 'URL',
            version: 'Version',
            service_class: 'Service Class',
            annotation_template: 'Annotation Template Class',
            groups: 'Groups',
            provide_runtime_context: 'Provide Runtime Context',
            publishers: 'Publishers',
            configuration: 'Configuration (XML)',
            publishers_placeholder: 'Select or type publisher types',
            edit: 'Edit',
            cancel: 'Cancel',
            empty: 'Not set',
            save: 'Save',
            saved: 'Deploy config saved',
            save_failed: 'Failed to save deploy config',
            load_failed: 'Failed to load deploy config',
            invalid: 'rules-deploy.xml is malformed',
            none: 'This project has no rules-deploy.xml yet. Fill the fields and save to create one.',
            migrate: 'Migrate',
            migrate_hint: 'Bring rules-deploy.xml to the current minimal form: drop the default runtime-context flag and rename the legacy template-class setting. The file is written anew, so its comments and layout are not kept.',
            migrate_failed: 'Failed to migrate rules-deploy.xml',
        },
        compile: {
            problems_expand: 'Show the compilation problems',
            problems_collapse: 'Hide the compilation problems',
            resize: 'Resize the problems panel',
            compiling: 'Compiling…',
            idle: 'Not compiled',
            ok: 'Compiled',
            warnings: 'Warnings',
            errors: 'Errors',
            error_count_one: '{{count}} error',
            error_count_other: '{{count}} errors',
            warning_count_one: '{{count}} warning',
            warning_count_other: '{{count}} warnings',
            show_more: 'Show {{count}} more',
            show_more_text: 'Show more',
            show_less: 'Show less',
        },
        live: 'live',
        commit: {
            show_more: 'Show more',
            show_less: 'Show less',
        },
        history: {
            open: 'Open Revision',
            open_failed: 'Failed to open revision',
            error: 'Failed to load history',
            none: 'No history',
            search: 'Search history',
            no_match: 'No revisions match',
            tech_revs: 'Show technical revisions',
            technical: 'technical',
            load_more: 'Load more',
        },
        status: {
            editing: 'In Editing',
            editing_hint: 'The project has changes that are not committed yet.',
            no_changes: 'No Changes',
            viewing_version: 'Viewing Revision',
            viewing_version_hint: 'The project is opened on an older revision, not on the latest one.',
            local: 'Local',
            closed: 'Closed',
            deleted: 'Deleted',
        },
        overview: {
            repository: 'Repository',
            branch: 'Branch',
            revision: 'Revision ID',
            copy_revision: 'Copy the full revision',
            revision_copied: 'Copied',
            path: 'Path',
            modified_by: 'Modified by',
            modified_at: 'Modified at',
            last_change: 'Modified',
            status: 'Status',
            tags: 'Tags',
            capabilities: 'Available actions',
            description: 'Description',
            comment: 'Comment',
            modules: 'Modules ({{count}})',
            modules_pattern: 'Modules matched by pattern',
            modules_auto: 'Auto-discovered modules',
            modules_auto_tests: 'Auto-discovered tests',
            modules_matched_show: 'Show the matched modules',
            modules_matched_hide: 'Hide the matched modules',
            dependency_missing: 'Not Found',
            dependency_transitive: 'Transitive',
            dependencies: 'Dependencies',
            depends_on: 'Depends on',
            used_by: 'Used by',
            version_patterns: 'Version patterns',
            pattern_help_open: 'How file name patterns work',
            pattern_help_title: 'Properties file name pattern',
            pattern_help_intro: 'Table properties can be defined for all tables of a module (module-level properties) in the file name of the module. A file name pattern can include:',
            pattern_help_text_symbols: 'text symbols;',
            pattern_help_property_names: 'table property names enclosed in "%" marks and separated by "-". Possible property names:',
            pattern_help_date_format: 'a date format when the table property value is of a date datatype. The date format is specified right after the property name and a colon:',
            pattern_help_date_format_link: 'Date format',
            pattern_help_same_type: 'several property names separated by a comma when they are of the same datatype:',
            pattern_help_several: 'several different patterns, each defined on a new line, when different behaviours are expected:',
            pattern_help_example: 'For example, for a pattern {{pattern}} a user can specify values for the properties "US State" and "Effective date" via the file name for the whole module.',
            pattern_help_inherited: 'The following module properties — US State = "Florida", Effective date = 02 Jan 2014 — will be retrieved and inherited by the module rules tables for a module with the file name {{file}}.',
            pattern_help_comma: 'To define several values for a property, the values should be separated by a comma. {{file}} will be determined as: US States = "Florida", "New York", Effective date = 02 Jan 2014.',
            pattern_help_any: 'The "Any" keyword in the file name means that all enumerable values will be set. {{file}} will be determined as: US States = "Alabama" … "Wyoming", Effective date = 02 Jan 2020.',
            pattern_help_no_match: 'If a file name does not match any of the patterns, then module properties are not defined for this module.',
            exposed_methods: 'Exposed methods',
            exposed_hint: 'Methods this project exposes when deployed as a rule service.\n'
                + 'External clients can only call what\'s listed here.\n'
                + 'If empty, every method in the project is exposed.',
            exposed_hint_edit: 'One pattern per line. Supports wildcards: * (any characters), ? (one character).',
            exposed_includes: 'Includes',
            exposed_excludes: 'Excludes',
            sources: 'Sources',
            openapi: 'OpenAPI',
            openapi_path: 'File',
            openapi_pick: 'Select a file from the project',
            openapi_upload: 'Upload',
            openapi_upload_failed: 'Failed to upload the OpenAPI file',
            openapi_mode: 'Mode',
            openapi_reconciliation: 'Reconciliation',
            openapi_reconciliation_hint: 'In this mode, the current project is validated by the OpenAPI file. To revalidate the project, change the path to the OpenAPI file.',
            openapi_generation: 'Tables generation',
            openapi_generation_hint: 'This mode is used for (re)generation of the Rules and Data Type modules based on the OpenAPI file.',
            openapi_model: 'Data types module',
            openapi_algorithm: 'Services module',
            properties_processor: 'Properties processor',
            edit: 'Edit',
            save: 'Save',
            cancel: 'Cancel',
            save_failed: 'Failed to save rules.xml',
            descriptor_read_failed: 'The rules.xml could not be read, so its declared values are not shown and cannot be edited.',
            list_add: 'Add',
            list_remove: 'Remove',
            list_reorder: 'Drag to reorder',
            module_name: 'Module name',
            module_path: 'Rules root path',
            dependency_name: 'Project name',
            dependency_auto_included: 'Auto-included',
            default_hint: 'Found automatically from the Excel files in the rules and tests folders. They are not listed in the project configuration.',
            sources_default_hint: 'Resolved automatically from the standard lib and groovy folders. They are not listed in the project configuration.',
            modules_auto_note: 'These modules are discovered automatically from the rules and tests folders. To add a module, put its Excel file in the rules or tests folder.',
            sources_auto_note: 'These sources are resolved automatically from the lib and groovy folders. To add a library, put its JAR file in the lib folder.',
            migrate: 'Migrate',
            migrate_before_edit: 'This project keeps its rules in the project root. Migrate it to move them into the rules folder before editing the project configuration — otherwise creating rules.xml would stop them from being found.',
            migrate_rewrite_hint: 'Bring rules.xml to the current minimal form.',
            migrate_move_confirm_one: 'This moves {{count}} workbook from the project root into the rules folder and creates a rules.xml so it is still found. Continue?',
            migrate_move_confirm_other: 'This moves {{count}} workbooks from the project root into the rules folder and creates a rules.xml so they are still found. Continue?',
            migrate_rewrite_confirm: 'This rewrites rules.xml to its minimal modern form, keeping the project behaviour. The file is written anew, so its comments and layout are not kept. Continue?',
            migrate_blocked: 'Migration is blocked — these workbooks would become modules: {{modules}}. Declare them in rules.xml or remove them, then migrate.',
            migrate_failed: 'Migration failed',
            unlock: 'Release lock',
        },
        editor: {
            save: 'Save',
            edit: 'Edit',
            cancel: 'Cancel',
            read_only: 'Read-only',
        },
        branch: {
            switch_failed: 'Failed to switch branch',
            filter: 'Filter branches',
            no_match: 'No branches match',
            default_tag: 'Default',
            protected_tag: 'Protected branch — direct commits and deletion are restricted; changes must go through a merge, and only a manager who can bypass protection may delete it.',
            load_failed: 'Failed to load branches',
        },
        publish: {
            deployments_title: 'Existing deployments',
            card_revision: 'Design Revision',
            card_deployed: 'Deployed',
            no_deployments: 'No active deployments',
            load_failed: 'Failed to load deployments',
        },
        access: {
            title: 'Per-project access: roles for users and groups',
            add: 'Add access',
            col_subject: 'Subject',
            col_type: 'Type',
            col_role: 'Role',
            col_source: 'Source',
            type_user: 'User',
            type_group: 'Group',
            source_project: 'Project',
            source_repository: 'Repository',
            inherited_readonly: 'Inherited from the repository and managed there',
            role_VIEWER: 'Viewer',
            role_CONTRIBUTOR: 'Contributor',
            role_MANAGER: 'Manager',
            remove: 'Remove',
            remove_confirm: 'Revoke access for "{{subject}}"?',
            none: 'No access assigned',
            load_failed: 'Failed to load access',
            update_failed: 'Failed to update access',
            remove_failed: 'Failed to remove access',
            dialog_title: 'Add access',
            dialog_desc: 'Assign a role to a user or group for {{name}}.',
            subject_type: 'Subject Type',
            subject_user_label: 'Username',
            subject_group_label: 'Group Name',
            subject_user_ph: 'user@company.com',
            subject_group_ph: 'rules-editors',
            role: 'Role',
            grant: 'Grant access',
            granted: 'Access granted to {{subject}}',
        },
        share: {
            button: 'Share',
            title: 'Share "{{name}}"',
            subject: 'User or group',
            grant: 'Grant',
            none: 'No access assigned',
            error: 'Failed to load access',
        },
        tags: {
            edit: 'Edit tags',
            none: 'Not tagged',
            key: 'Tag',
            value: 'Value',
            save: 'Save',
            cancel: 'Cancel',
            duplicate_keys: 'Each tag can be used only once',
        },
        create: {
            title: 'New project in "{{repository}}"',
            hint: 'Upload a project archive (.zip) to create a new project.',
            wizard_title: 'Create project',
            wizard_desc: 'Choose how to create a project with business rules.',
            back: 'Back',
            mode_archive_desc: 'Import from a .zip archive',
            mode_excel_desc: 'Upload .xlsx rule files',
            mode_openapi_desc: 'Generate from a specification',
            mode_template_desc: 'Built-in and custom templates',
            mode_workspace_desc: 'Save local projects to a repository',
            mode_copy: 'Copy project',
            mode_copy_desc: 'Copy an existing project',
            copy_source: 'Source project',
            copy_source_label: 'Source',
            copy_source_required: 'Select a project to copy',
            mode_archive: 'From archive',
            mode_excel: 'From Excel files',
            mode_template: 'From template',
            template_required: 'Select a template',
            template_custom: 'custom',
            mode_workspace: 'From workspace',
            workspace_select_all: 'Select all',
            workspace_required: 'Select at least one local project',
            workspace_empty: 'No local projects to save',
            repository_label: 'Repository',
            branch: 'Branch',
            branch_required: 'Enter a branch name',
            branch_invalid: 'Enter a valid Git branch name that matches the pattern the repository requires',
            mode_openapi: 'From OpenAPI',
            openapi_hint: 'Click or drag an OpenAPI (.json/.yaml) file here',
            openapi_required: 'Select an OpenAPI file',
            openapi_data_module: 'Module Name for Data Types',
            openapi_data_path: 'Path for Module with Data Types',
            openapi_rules_module: 'Module Name for Rules',
            openapi_rules_path: 'Path for Module with Rules',
            openapi_modules_required: 'Fill in all module names and paths',
            openapi_defaults: {
                data_module_name: 'Models',
                data_module_path: 'rules/Models.xlsx',
                rules_module_name: 'Algorithms',
                rules_module_path: 'rules/Algorithms.xlsx',
            },
            name: 'Project Name',
            name_required: 'Enter a project name',
            archive_hint: 'Click or drag a .zip archive here',
            archive_subhint: 'Supports .zip up to 50 MB',
            archive_invalid: 'This archive is not an OpenL project: its root has no rules.xml and no Excel file.',
            source_zip: 'Archive',
            source_folder: 'Folder',
            folder_hint: 'Click or drag a project folder here',
            folder_subhint: 'The folder is zipped in your browser and validated like an archive',
            folder_selected_one: '{{count}} file selected',
            folder_selected_other: '{{count}} files selected',
            folder_zipping: 'Preparing the folder…',
            excel_hint: 'Click or drag .xlsx/.xls files here',
            file_required: 'Select a .zip archive',
            excel_required: 'Select at least one Excel file',
            path: 'Path',
            submit: 'Create',
            cancel: 'Cancel',
        },
    },
    tabs: {
        design_repositories: 'Design Repositories',
        deployment_repositories: 'Deployment Repositories',
    },
    confirm_delete_repository: 'Are you sure you want to delete this repository?',
    confirm_delete_repository_message: 'This action cannot be undone. All users working with OpenL Studio now will lose all unsaved changes. Are you sure you want to delete this repository now?',
    confirm_apply_configuration: 'Are you sure you want to apply the configuration?',
    confirm_apply_configuration_message: 'All users working with OpenL Studio now will lose all unsaved changes. Are you sure you want to apply this configuration now?',
    confirm_leave_without_saving: 'You have unsaved changes',
    confirm_leave_without_saving_message: 'Are you sure you want to leave without saving?',
    add_design_repository: 'Add Design Repository',
    add_deployment_repository: 'Add Deployment Repository',
    no_repositories_available: 'No repositories available',
    click_add_repository_to_create_first: 'Click "Add {{type}} Repository" to create your first repository.',
    design: 'Design',
    deployment: 'Deployment',
    messages: {
        waiting_for_repository_operation: 'Please wait while processing repository operation...',
    },
    buttons: {
        apply_changes: 'Apply Changes',
    },
    notifications: {
        repository_deleted: 'Repository deleted',
        repository_deleted_description: 'The repository has been successfully deleted.',
        configuration_applied: 'Configuration applied',
        configuration_applied_description: 'Repository configuration changes have been successfully applied.',
        branch_deleted: 'Branch deleted',
        branch_deleted_description: 'Branch "{{branch}}" was deleted successfully.',
        branch_delete_failed: 'Branch deletion failed',
        project_deleted: 'Project deleted',
        project_deleted_description: 'Project "{{project}}" was deleted successfully.',
        project_delete_failed: 'Project deletion failed',
        file_deleted: 'File deleted',
        file_deleted_description: 'File "{{name}}" was deleted successfully.',
        file_delete_failed: 'File deletion failed',
        folder_deleted: 'Folder deleted',
        folder_deleted_description: 'Folder "{{name}}" was deleted successfully.',
        folder_delete_failed: 'Folder deletion failed',
    },
    delete_project_modal: {
        title: 'Confirm Delete',
        confirm: 'Are you sure you want to delete the "{{project}}" project?',
        comment_label: 'Please define a comment why you decide to delete "{{project}}" project',
        confirmation: 'I understand that the project will be deleted.',
        confirm_button: 'Delete',
    },
    delete_file_modal: {
        title: 'Confirm Delete',
        confirm_file: 'Are you sure you want to delete the file "{{name}}"?',
        confirm_folder: 'Are you sure you want to delete the folder "{{name}}"?',
        confirm_button: 'Delete',
    },
    delete_branch: {
        title: 'Delete branch',
        confirm: 'Are you sure you want to delete branch "{{branch}}"?',
        modified_warning: 'The project is modified. If you delete the branch, all changes will be lost.',
        last_branch_warning: 'No other branch contains this project, so deleting the branch deletes the project.',
        protected_warning: 'This branch is protected. Deleting it requires the right to bypass branch protection; the repository refuses the deletion otherwise.',
        not_merged_warning: 'Branch "{{branch}}" is not merged into the "{{mainBranch}}" branch. All unmerged changes will be lost and cannot be restored.',
        confirm_button: 'Delete',
        confirm_button_unsafe: 'I understand the consequences, delete this branch',
    },
})
